export const CLASS_SEGMENT = "pi-segment";
export const CLASS_SEGMENT_CREATED = "pi-segment-created";

/*
Сегмент - это HTML элемент, у которого есть один или несколько потомков в дереве, помеченных для парсинга.
Каждый сегмент - это потенциально обобщаемый блок (можно повторить один или несколько раз, в рамках прямого родителя
этого элемента).
*/
export class Segment {
    elem: HTMLElement
    children: Set<HTMLElement>

    constructor(elem: HTMLElement) {
        this.elem = elem
        this.children = new Set<HTMLElement>();
    }

    addChild(elem: HTMLElement) {
        this.children.add(elem);

        if (this.children.size >= 2 && !this.elem.classList.contains(CLASS_SEGMENT)) {
            this.elem.classList.add(CLASS_SEGMENT);
        }
    }

    removeChild(elem: HTMLElement) {
        this.children.delete(elem);

        if (this.children.size < 2) {
            this.elem.classList.remove(CLASS_SEGMENT)
        }
    }

    public static fromElem(elem: HTMLElement): Segment {
        let segment = (elem as any).pisegment as Segment;
        if (!segment) {
            segment = new Segment(elem);
            (elem as any).pisegment = segment;
            elem.classList.add(CLASS_SEGMENT_CREATED);
        }

        return segment;
    }

    static addToSegments(elem: HTMLElement) {
        let curElem = elem.parentElement;
        while (curElem != null && curElem != elem.ownerDocument.body) {
            const segment = Segment.fromElem(curElem);
            segment.addChild(elem);
            if (segment.children.size > 1) {
                break;
            }

            curElem = curElem.parentElement;
        }
    }

    static removeFromSegments(elem: HTMLElement) {
        let curElem = elem.parentElement;
        while (curElem != null && curElem != elem.ownerDocument.body) {
            Segment.fromElem(curElem).removeChild(elem);

            curElem = curElem.parentElement;
        }
    }

    static resetSegments(document: Document) {
        for (const elem of document.getElementsByClassName(CLASS_SEGMENT_CREATED)) {
            const segment = Segment.fromElem(elem as HTMLElement);
            segment.children.clear();
        }
    }
}


